import {
  EWorkshopPartType,
  TWorkshopTaskUI,
} from 'data/types/workshopTasks.types';

// Part labels per Confluence spec "(2235) RFK - Task Management" §3.2: Prep / 1 / 2 / 3 / Post.
// STANDALONE (single-session workshops) is not numbered in the spec, so it reads "Session".
export const SECTION_LABEL: Record<EWorkshopPartType, string> = {
  [EWorkshopPartType.PREP]: 'Prep',
  [EWorkshopPartType.STANDALONE]: 'Session',
  [EWorkshopPartType.PART_ONE]: '1',
  [EWorkshopPartType.PART_TWO]: '2',
  [EWorkshopPartType.PART_THREE]: '3',
  [EWorkshopPartType.POST]: 'Post',
};

export const SECTION_ORDER: EWorkshopPartType[] = [
  EWorkshopPartType.PREP,
  EWorkshopPartType.STANDALONE,
  EWorkshopPartType.PART_ONE,
  EWorkshopPartType.PART_TWO,
  EWorkshopPartType.PART_THREE,
  EWorkshopPartType.POST,
];

const PART_RANK = SECTION_ORDER.reduce(
  (acc, part, index) => ({ ...acc, [part]: index }),
  {} as Record<EWorkshopPartType, number>,
);

// The spec calls for one stacked list ordered Prep -> 1 -> 2 -> 3 -> Post,
// then by task order within a part. Used only when no column sort is active.
export const sortTasksByPart = (tasks: TWorkshopTaskUI[]): TWorkshopTaskUI[] =>
  [...tasks].sort((a, b) => {
    const partDiff = PART_RANK[a.part] - PART_RANK[b.part];
    if (partDiff !== 0) return partDiff;
    return a.order - b.order;
  });
